import { all, put, select, takeEvery, takeLatest } from 'redux-saga/effects'
import { createPersonBegin, fetchPeople, updatePersonBegin } from 'scenes/Dashboard/data/people/actions'
import { ActionType, getType } from 'typesafe-actions'

import {
  closePersonForm,
  createPerson,
  getFilteredPeople,
  updateCurrentPage,
  updatePerson,
  updateSearch,
} from './actions'
import { getPeopleManagerState } from './selectors'

export function* peopleManagerSaga() {
  yield all([
    takeLatest(
      [getType(getFilteredPeople), getType(updateCurrentPage), getType(updateSearch)],
      getFilteredPeopleEffect
    ),
    takeEvery(getType(updatePerson), updatePersonSaga),
    takeEvery(getType(createPerson), createPersonSaga),
  ])
}

function* getFilteredPeopleEffect() {
  const { currentPage, limit, search } = yield select(getPeopleManagerState)

  yield put(fetchPeople.request({ currentPage, limit, searchQuery: search }))
}

function* updatePersonSaga(action: ActionType<typeof updatePerson>) {
  const { person } = action.payload
  yield put(updatePersonBegin(person))
  yield put(closePersonForm())
}

function* createPersonSaga(action: ActionType<typeof createPerson>) {
  const { person } = action.payload
  yield put(createPersonBegin(person))
  yield put(closePersonForm())
}
